import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon, ShieldCheckIcon, ZapIcon, LockIcon, CreditCardIcon } from 'lucide-react';
const includes = ['Mindfulness — Kit Antiestrés para el Trabajo', 'Kit Práctico de Conversaciones Difíciles', '100 Respuestas para Situaciones Difíciles', 'Ejercicios Prácticos para Mejorar el Ambiente Laboral', 'Más de 60 páginas', 'Descarga digital', 'Acceso de por vida', 'Acceso desde cualquier dispositivo'];
export function OfferSection() {
  return <section id="oferta" className="w-full py-20 md:py-28 px-4" data-id="element-173" data-mp="md8q8a6tv80c">
      <div className="max-w-3xl mx-auto" data-id="element-174" data-mp="rdn1e13q6y2l">
        {/* Offer card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-white border border-rose/30 rounded-3xl p-7 md:p-10 shadow-2xl shadow-rose/10" data-id="element-175" data-mp="wczjk8jnjgyu">
          <div className="text-center mb-6" data-id="element-176" data-mp="xwjw4jipb9p6">
            <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-3 py-1 rounded-full mb-4" data-id="element-177" data-mp="xup7ov880zgc">
              <span className="text-[11px] font-bold tracking-widest" data-id="element-178" data-mp="svcockgk6aii">
                ⭐ OFERTA ESPECIAL
              </span>
            </div>
            <h2 className="font-serif font-bold text-3xl md:text-4xl text-ink uppercase tracking-tight leading-tight" data-id="element-179" data-mp="1llbekj6hodor">
              Kit Antiestrés{' '}
              <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-180" data-mp="1glgqene3m27e">
                para el Trabajo
              </span>
            </h2>
            <p className="font-serif-italic text-rose text-lg mt-2" data-id="element-181" data-mp="17ltkppec6a8j">
              4 materiales completos · +60 páginas
            </p>
          </div>

          {/* Price */}
          <div className="text-center mb-7" data-id="element-182" data-mp="3scat77p2tjov">
            <div className="text-muted mb-2 text-[14px]" data-id="element-183" data-mp="3sbizy3iyby1r">
              Valor individual: <span className="line-through" data-id="element-184" data-mp="3tvauc4bu9ed7">$39.990</span>
            </div>
            <div className="flex items-baseline justify-center gap-2 flex-wrap" data-id="element-185" data-mp="2nydjqevb2xt">
              <span className="font-serif font-bold text-5xl md:text-6xl text-rose" data-id="element-186" data-mp="3ktl3p0ps6jgh">
                $19.990
              </span>
              <span className="text-lg text-ink-soft" data-id="element-187" data-mp="3otvb8ht81hxg">ARS</span>
            </div>
            <div className="inline-flex items-center gap-2 bg-rose text-white text-xs font-black px-3 py-1 rounded-full mt-3" data-id="element-188" data-mp="3b2zwwpzye8mh">
              50% OFF
            </div>
            <div className="text-sm text-muted mt-2" data-id="element-189" data-mp="3fw1hnemud2dz">
              Pago único · Acceso de por vida
            </div>
          </div>

          {/* Includes */}
          <div className="bg-bg-warm border border-line rounded-2xl p-5 md:p-6 mb-7" data-id="element-190" data-mp="3656tu5ty5uqf">
            <div className="text-xs font-bold text-rose tracking-widest mb-4 text-center" data-id="element-191" data-mp="2s5p0re9mbvb9">
              INCLUYE TODO ESTO
            </div>
            <ul className="space-y-2.5" data-id="element-192" data-mp="2x5teiwj56bxs">
              {includes.map((it, i) => <li key={i} className="flex items-start gap-3 text-sm" data-id="element-193" data-mp="2di749367m6zx" data-mpi={i}>
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-rose/15 flex items-center justify-center mt-0.5" data-id="element-194" data-mp="28jvsuo09nofl">
                    <CheckIcon className="w-3 h-3 text-rose" strokeWidth={3} data-id="element-195" data-mp="2mjy6tz5gdxpk" />
                  </span>
                  <span className="text-ink" data-id="element-196" data-mp="2ifqgxyn9ebpr">{it}</span>
                </li>)}
            </ul>
          </div>

          <a href="https://checkout.aula-mater.online/" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout');
          }
        }} className="flex items-center justify-center gap-2 w-full bg-rose hover:bg-rose-deep text-white font-bold text-lg md:text-xl py-5 rounded-full text-center shadow-xl shadow-rose/30 hover:-translate-y-0.5 transition-all" data-id="element-197" data-mp="2rhpyqt63ljtr">
            <ArrowRightIcon className="w-5 h-5" data-id="element-198" data-mp="18is3yczzku60" />
            QUIERO MI KIT ANTIESTRÉS
          </a>

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-6 text-xs text-muted" data-id="element-199" data-mp="1dg0kya9ees5o">
            <span className="flex items-center gap-1.5" data-id="element-200" data-mp="1ib7kr6zjrcpb">
              <LockIcon className="w-3.5 h-3.5 text-rose" data-id="element-201" data-mp="1m959y9tbhysp" /> Pago seguro
            </span>
            <span className="text-line" data-id="element-202" data-mp="pl7m3pvn2vuw">|</span>
            <span className="flex items-center gap-1.5" data-id="element-203" data-mp="pmipvpp343m0">
              <ZapIcon className="w-3.5 h-3.5 text-rose" data-id="element-204" data-mp="uk23cndykccw" /> Acceso en 5 min
            </span>
            <span className="text-line" data-id="element-205" data-mp="yjszz7q61mpc">|</span>
            <span className="flex items-center gap-1.5" data-id="element-206" data-mp="yn73wkeha3yw">
              <ShieldCheckIcon className="w-3.5 h-3.5 text-rose" data-id="element-207" data-mp="13kqhdi3cqcps" /> Garantía 7
              días
            </span>
            <span className="text-line" data-id="element-208" data-mp="29zrh7yvhzf1n">|</span>
            <span className="flex items-center gap-1.5" data-id="element-209" data-mp="2eyueuy95eizl">
              <CreditCardIcon className="w-3.5 h-3.5 text-rose" data-id="element-210" data-mp="2ex9jj6f0ew0o" /> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}